import { Observable } from "rxjs";
import { FileUploadError } from "./file.error.utils";
import { HttpHeaders } from "@angular/common/http";

export function convertToCustomUpload(file: File): FormData {
    if (!file) {
        throw new FileUploadError("Aucun fichier fourni. Veuillez sélectionner un fichier.");
    }

    const formData = new FormData();
    formData.append('file', file);
    return formData;
}

/**
 *
 * @param file Converts File to string
 * @returns Observable<string>
 */
export function  readFileContent(file: File): Observable<string> {
    return new Observable<string>((observer) => {
        if (!file) {
            observer.next('');
            observer.complete();
            return;
        }

        const reader = new FileReader();

        reader.onload = () => {
            const text = reader.result?.toString();
            observer.next(text ?? '');
            observer.complete();
        };

        reader.onerror = (error) => {
            observer.error('Erreur lors de la lecture du fichier : ' + error);
        };

        reader.readAsText(file);
    });
  }


export function readFileContentByte(file: File): Observable<Uint8Array> {
  return new Observable<Uint8Array>((observer) => {
    if (!file) {
      observer.next(new Uint8Array(0));
      observer.complete();
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const arrayBuffer = reader.result as ArrayBuffer;
      const byteArray = new Uint8Array(arrayBuffer);
      observer.next(byteArray);
      observer.complete();
    };

    reader.onerror = (error) => {
      observer.error('Erreur lors de la lecture du fichier : ' + error);
    };

    reader.readAsArrayBuffer(file);
  });
}

export function getNameWithoutExtension(fileName: string): string {
  const lastDotIndex = fileName.lastIndexOf(".");

  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return fileName;
  }

  return fileName.substring(0, lastDotIndex);
}


export function downloadFileOnLocal(param: { blob: Blob; fileName: string | undefined }): void {
  try {
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(param.blob);
    link.href = url;
    link.download = param.fileName || "exported-file";
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  }
}

  export function extractFileNameFromContentDisposition(
    response: HttpHeaders
  ): string {
    const contentDisposition = response.get("content-disposition");
    if (!contentDisposition) return "unknownFileName.xlsm";

    const match = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^"]+)"?/);

    if (match) {
      // Use decodeURIComponent to decode encoded names (useful for accents, spaces, etc.).
      return decodeURIComponent(match[1] || match[2]).trim();
    }

    return "unknownFileName.xlsm";
  }
